/* BB PDP — winners rail + sticky ATC. Countdown is handled globally
   by bb-timer.js (single 48h source); no timer logic here anymore. */
(function () {
  'use strict';
  var scope = document.querySelector('.bb-pdp');
  if (!scope) return;

  /* ---- winners rail ---- */
  var track = scope.querySelector('.bb-rail-track');
  if (track) {
    scope.querySelectorAll('.bb-rail-arrow').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var card = track.querySelector('.bb-winner-card');
        var step = card ? card.getBoundingClientRect().width + 14 : 240;
        track.scrollBy({ left: btn.getAttribute('data-bb-dir') === 'next' ? step : -step, behavior: 'smooth' });
      });
    });
  }

  /* ---- sticky ATC ---- */
  var sticky = scope.querySelector('.bb-sticky');
  if (!sticky) return;
  var realAtc = document.querySelector('.product-form__submit, .product-form__cart-submit, .btn-addToCart, button[name="add"]');
  if (!realAtc) { sticky.remove(); return; }
  var stickyBtn = sticky.querySelector('button');
  if (stickyBtn) { stickyBtn.addEventListener('click', function () { realAtc.click(); }); }

  var pastAtc = false, footerVisible = false;
  function apply() { sticky.classList.toggle('is-visible', pastAtc && !footerVisible); }
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      pastAtc = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
      apply();
    }, { threshold: 0 }).observe(realAtc);
    var footerEl = document.querySelector('#shopify-section-footer') || document.querySelector('.wrapper-footer') || document.querySelector('footer');
    if (footerEl) {
      new IntersectionObserver(function (entries) {
        footerVisible = entries[0].isIntersecting;
        apply();
      }, { threshold: 0 }).observe(footerEl);
    }
  }
})();
